<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/120CYUI/images/9781439643754.jpg?1684306200790" alt="This image is the cover for the book USS Alabama, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">USS Alabama, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Powerful: this single word aptly describes a naval vessel known as a battleship. The USS Alabama (BB-60) was the last of four South Dakota-class battleships built for World War II.</b></p><br/><p>She is well armored and designed to survive an attack while continuing to fight. Her main battery, known as "Big Guns," consisted of nine 16-inch guns; each could launch a projectile weighing as much as a small car that could hit a target 21 miles away. Her crew numbered 2,332 men, none of whom were lost to enemy fire, earning her the nickname "Lucky A." She served as more than just a battleship: she carried troops, supplies, and seaplanes and served in the Pacific and Atlantic; her doctors treated patients from other ships; she was the wartime home for a major-league ballplayer; the movie setting for Hollywood films; and she traveled home to the state of Alabama with the help of schoolchildren.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kent Whitaker, , Bill Tunnell
      </h2>
      
      <p class="authorDescription body article">Author Kent Whitaker and Bill Tunnell, executive director of the USS Alabama Battleship Memorial Park, visually chart the course of the USS Alabama from the day her keel was laid to her present service as a museum ship and memorial in Mobile, Alabama.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3c4a7d62